import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const SectionLabel = ({ children, light = false }) => (
    <span
        className={`inline-flex items-center gap-3 text-xs tracking-[0.25em] uppercase font-bold ${
            light ? "text-white/70" : "text-navy/60"
        }`}
    >
        <span className="h-px w-10 bg-brand inline-block" />
        {children}
    </span>
);
